import gql from 'graphql-tag';

export const CREATE_MUTATION = gql`
  mutation createCategory(
    $name: String!
    $nameLang: TranslatedStringCreateOneWithoutCategoryNameInput
    $description: String
    $descriptionLang: TranslatedStringCreateOneWithoutCategoryDescriptionInput
    $parentId: String
    $order: Int
    $color: String
    $imageId: ID
    $companyId: ID
    $vatRate: Int
    $courseType: CourseTypeCreateOneWithoutCategoriesInput
  ) {
    node: createCategory(
      name: $name
      nameLang: $nameLang
      description: $description
      descriptionLang: $descriptionLang
      order: $order
      parentId: $parentId
      color: $color
      imageId: $imageId
      companyId: $companyId
      vatRate: $vatRate
      courseType: $courseType
    ) {
      id
      name
      company {
        id
      }
      vatRate
      ukVatRate
      courseType {
        id
        name
      }
    }
  }
`;

export const UPDATE_MUTATION = gql`
  mutation updateCategory($id: ID!, $data: CategoryUpdateInput!) {
    node: updateCategory(where: { id: $id }, data: $data) {
      id
      name
      vatRate
      ukVatRate
      company {
        id
      }
    }
  }
`;

export const NODE_QUERY = gql`
  query getNode($id: ID) {
    node: Category(id: $id) {
      id
      name
      vatRate
      ukVatRate
      hideInCustomerOrderingFlows
      company {
        id
      }
      nameLang {
        id
        se
        en
        es
        no
      }
      parentId
      description
      descriptionLang {
        id
        se
        en
        es
        no
      }
      order
      color
      tags

      image {
        id
        file {
          id
          url
        }
        title
        updatedAt
      }

      courseType {
        id
        label
      }
    }
  }
`;
